import React, { useState, useEffect } from "react";
import ClienteListViewTable from './ClientesTable';
import InputMask from "react-input-mask";
import { api } from "../../components/api/api";
import ModalNovoCliente from "../../components/Modals/Clients/NovoCliente";
import DetalhesDoCliente from '../../components/Modals/Clients/DetalhesCliente';
import Filter from '../../components/filter/filter';
import { GetDataUser } from "../../util/GetDataUser";
import { buscarClientes } from "../../components/api/apiMiddle";
import { eTipoDownload } from "../../enum/eTipoDownload";
import { FaUsers } from "react-icons/fa";
import { Alert, Pergunta, AlertErro } from "../../util/Alertas";

function ClienteListView() {
    const [clientes, setClientes] = useState([]);
    const [clienteSelecionado, setClienteSelecionado] = useState(null);
    const [modalAberto, setModalAberto] = useState(false);
    const [filtroNome, setFiltroNome] = useState("");
    const [clienteData, setClienteData] = useState({});
    const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
    const [isPessoaFisica, setIsPessoaFisica] = useState(true);
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [diasSelecionados, setDiasSelecionados] = useState([]);
    const [horasSelecionados, sethorasSelecionados] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const usuario = GetDataUser();

    const BuscarTodosVendedores = () => {
        api.get("/Usuario/Vendedores", res => {
            setVendedores(res.data);
        }, erro => {
            AlertErro(erro)
        })
    }

    const fetchClientes = (query, dtInicio, dtFim) => {

        api.get(`api/Cliente/BuscarClientes?q=${query || ""}&dtInicio=${dtInicio || ""}&dtFim=${dtFim || ""}`, res => {
            setClientes(res.data);
        }, error => {
            AlertErro(error, 'Erro ao buscar clientes.');

        })
    };

    useEffect(() => {
        fetchClientes();
        BuscarTodosVendedores();
    }, []);

    const handleAbrirModal = (cliente) => {
        if (cliente) {
            setIsPessoaFisica(cliente.pessoaFisica);
            setClienteData(cliente);
            setClienteSelecionado(cliente);
            setDiasSelecionados(cliente.dias)
            sethorasSelecionados(cliente.horas)
        } else {
            setIsPessoaFisica(true);
            setClienteData({});
            setClienteSelecionado(null);
        }
        setModalAberto(true);
    };

    const handleAbrirModalDetalhe = (cliente) => {
        setClienteSelecionado(cliente);
        setModalDetalhesAberto(true);
    };

    const handleSalvarCliente = async () => {
        try {
            if (clienteSelecionado)
                clienteData.clienteId = clienteSelecionado.clienteId;

            clienteData.PessoaFisica = isPessoaFisica;
            clienteData.Horarios = horasSelecionados.join('|');
            clienteData.Dias = diasSelecionados.join('|');

            const { dias, horarios, ...clienteDataSemDiasEHorarios } = clienteData;

            api.post(`api/Cliente/${clienteSelecionado ? "AtualizaDadosCliente" : "NovoCliente"}`,
                clienteDataSemDiasEHorarios, res => {

                    const loader = document.getElementById(`loadingpanel`);
                    if (loader)
                        loader.style.display = 'none';

                    fetchClientes();
                    setModalAberto(false);
                    Alert("Cliente salvo com sucesso!");
                }, erro => {
                    AlertErro(erro);
                });

        } catch (error) {
            console.error("Erro ao salvar cliente:", error);
        }
    };

    const handleInputChange = async (event) => {
        const { value } = event.target;
        fetchClientes(value, dataInicio, dataFim);
        setFiltroNome(value);
    };

    const toggleStatus = async (statusAtual, id) => {
        if (await Pergunta("Deseja realmente atualizar o status desse cliente?"))
            try {
                api.post(`api/Cliente/${statusAtual ? "AtivaCliente" : "InativaCliente"}/${id}`,
                    {}, res => {
                        fetchClientes();
                        Alert("Cliente atualizado com sucesso!");
                    });
            } catch (error) {
                AlertErro(error, 'Erro ao alterar o status do cliente');
            }
    };

    return (
        <div className="App" style={{ width: '100%' }}>
            <ModalNovoCliente
                modalAberto={modalAberto}
                setModalAberto={setModalAberto}
                setIsPessoaFisica={setIsPessoaFisica}
                clienteData={clienteData}
                setClienteData={setClienteData}
                handleSalvarCliente={handleSalvarCliente}
                InputMask={InputMask}
                isPessoaFisica={isPessoaFisica}
                clienteSelecionado={clienteSelecionado}
                horasSelecionados={horasSelecionados}
                sethorasSelecionados={sethorasSelecionados}
                diasSelecionados={diasSelecionados}
                setDiasSelecionados={setDiasSelecionados}
                vendedores={vendedores}
            />
            <DetalhesDoCliente
                modalDetalhesAberto={modalDetalhesAberto}
                setModalDetalhesAberto={setModalDetalhesAberto}
                clienteSelecionado={clienteSelecionado}
            />
            <div className="content">
                <div className="container-table">
                    <Filter
                        filtroNome={filtroNome}
                        handleInputChange={handleInputChange}
                        handleAbrirModal={handleAbrirModal}
                        setDataInicio={setDataInicio}
                        setDataFim={setDataFim}
                        fetchClientes={fetchClientes}
                        dataInicio={dataInicio}
                        dataFim={dataFim}
                        showNovoCliente={true}
                        tipoDownload={eTipoDownload.Clientes}
                        extrairDados={true}
                    />
                    <br />
                    <ClienteListViewTable
                        clientes={clientes}
                        toggleStatus={toggleStatus}
                        handleAbrirModal={handleAbrirModal}
                        handleAbrirModalDetalhe={handleAbrirModalDetalhe}
                    />
                </div>
            </div>
        </div>
    );
}

export default ClienteListView;
